// extracted by mini-css-extract-plugin
export default {"form":"EditVoiceModal_form__vMuEk","hr":"EditVoiceModal_hr__48gBk","two":"EditVoiceModal_two__wYf9D"};